import { useBaseHook } from './useBaseHook'

export const useDelete = (API) => {

    const { onApply } = useBaseHook(API)

    const onDelete = (id) => onApply("delete-operation", id)

    return { onDelete }
}
